// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"7bf7b3dc","468":"6c98c2a9"}[chunkId] + ".chunk.js";
};